import { render, staticRenderFns } from "./EditContract.vue?vue&type=template&id=c8d8079e&scoped=true&"
import script from "./EditContract.vue?vue&type=script&lang=js&"
export * from "./EditContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8079e",
  null
  
)

export default component.exports